/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Pos_Place_OrderInputs */

const vi_pos_place_order = /** @type {(inputs: Pos_Place_OrderInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ĐẶT HÀNG — ${i?.amount}`)
};

/**

* @param {Pos_Place_OrderInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pos_place_order = /** @type {((inputs: Pos_Place_OrderInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pos_Place_OrderInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pos_place_order(inputs)
});